import React from 'react';

const Footer: React.FC = () => (
  <footer
    className="footer"
    style={{
      background: '#090909',
      width: '100%',
      minHeight: 48,
      position: 'relative',
      marginTop: 'auto',
      padding: 0
    }}
  >
    <hr
      className="footer-line"
      style={{
        border: 'none',
        borderTop: '1px solid #222',
        margin: 0
      }}
    />
    <div
      className="footer-content"
      style={{
        color: '#acacac',
        fontSize: '1.1rem',
        fontFamily: "'Segoe UI', 'Inter', Arial, Helvetica, sans-serif",
        fontWeight: 400,
        letterSpacing: '0.01em',
        padding: '16px 32px 12px 0',
        textAlign: 'right',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
      }}
    >
      © Velours 2025
    </div>
  </footer>
);

export default Footer;